export const formHasTickets = ({ tickets }) => {
  return (tickets?.reduce((acc, { quantity }) => (acc + quantity), 0) > 0)
}
